// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"mZ-z","subtitle":"nZ-z","wrapper":"oZ-z","leftArrow":"pZ-z","rightArrow":"qZ-z"};